<template>
    <div>
        <div class="profile-block">
            <div class="details-left">

                <div class="profile-img">
                    <!--<i class="ivu-icon ivu-icon-ios-close" v-show="showDeleteButton" @click="showRemoveAvatarModal=true"></i>-->
                    <!--<img :src="profileUrl" :alt="teacher.name" class="rounded-circle float-left">-->
                    <div class="teacher-avatar" :style="'background-image: url('+profileUrl+')'"></div>
                </div>
                <div class="profile-details">
                    <edit-profile></edit-profile>

                    <h5 class="title-5">{{teacher.name}}</h5>
                    <span>{{teacher.grade_taught}}</span>
                    <address>
                        <p>
                            {{teacher.school}} <br/>
                            {{teacher.district}} <br/>
                            {{teacher.city}} {{teacher.state}}&nbsp;{{teacher.zip}} <br/>
                            {{teacher.account_school_farl_percentage}}% National School Lunch Program
                        </p>
                    </address>
                </div>
            </div>

            <!--<login-button></login-button>-->

        </div>
        <div class="text-block">
            <p class="paragraph" v-html="story"></p>
        </div>
        <modal title="Remove Avatar"
               v-model="showRemoveAvatarModal"
               class-name="vertical-center-modal warning-modal">
            <p style="font-size: 14pt">This action will remove this image permanently, do want continue?</p>
            <template slot="footer">
                <div class="text-center">
                    <button class="solid-btn outline" @click="showRemoveAvatarModal=false">No</button>
                    <button class="solid-btn" @click="removeImage">Yes</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  mounted () {
    kinfEvents.$on('TeachersAvatarAdded', ev => {
      this.imageAdded = ev
      this.imageRemoved = false
    })
    kinfEvents.$on('TeachersAvatarRemoved', ev => {
      this.imageRemoved = true
      this.imageAdded = null
      this.$forceUpdate()
    })
  },
  props: {
    teacher: {
      type: Object,
      required: true
    },
    teacherId: {
      required: true
    },
    story: {
      type: String,
      required: true
    },
    user: {
      required: true
    },
    fundraiser: {
      required: true
    }
  },
  data () {
    return {
      showRemoveAvatarModal: false,
      authenticated: false,
      imageRemoved: false,
      imageAdded: null
    }
  },
  computed: {
    profileUrl () {
      if (this.imageAdded !== null) {
        return this.imageAdded
      }

      if (this.teacher.teacher_image_uri !== null && !this.imageRemoved) {
        return this.teacher.teacher_image_uri
      }

      if (this.fundraiser.fundraiser_image_url !== null) {
          return this.fundraiser.fundraiser_image_url
      }

      return '/images/content/teacher-tb.png'
    },
    showDeleteButton () {
      if (this.imageRemoved) {
        return false
      }
      if (this.imageAdded !== null) {
        return true
      }

      return this.user !== null && this.user.id === this.teacherId && this.teacher.teacher_image_uri !== null
    }
  },
  methods: {
    removeImage () {
      const uri = window.App.globalData.routes.post_remove_image
      const loading = this.$loading({ fullscreen: true })
      axios.delete(uri).then(response => {
        loading.close()
        this.imageRemoved = true
        this.$notify({
          title: 'Success',
          message: response.data.response.message,
          type: 'success'
        })
        this.imageAdded = null
        this.showRemoveAvatarModal = false
        kinfEvents.$emit('TeachersAvatarRemoved')
      }).catch(e => console.log(e))
    }
  }
}
</script>

<style>
    .teacher-avatar {
        position: relative;
        width: 112px;
        height: 112px;
        -webkit-border-radius: 60px;
        -webkit-background-clip: padding-box;
        -moz-border-radius: 60px;
        -moz-background-clip: padding;
        border-radius: 60px;
        background-clip: padding-box;
        margin: 7px 0 0 5px;
        /*float: left;*/
        background-size: cover;
        background-position: center center;
    }

    .profile-img {
        overflow: initial !important;
    }

    i.ivu-icon.ivu-icon-ios-close {
        position: relative;
        display: block;
        z-index: 100;
        float: right;
        top: 0px;
        right: 0px;
        border-radius: 100%;
        background: white;
        cursor: pointer;
        border: 1px solid #d9232e;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #d9232e;
        font-weight: bolder;
        font-size: 21px;
        /*margin-bottom: 15px;*/
    }

    i.ivu-icon.ivu-icon-ios-close:hover {
        color: #fb202d;
        border-color: #fb202d;
    }

    i.ivu-icon.ivu-icon-ios-close:active {
        color: #bf131f;
        border-color: #bf131f;
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/FundraiserProfile.vue